var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChairIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 14.026c.553 0 1-.445 1-.994V6.955a.998.998 0 0 1 1-.994h1v9.058C4 16.663 5.346 18 7 18h6c1.654 0 3-1.337 3-2.98V5.96h1c.552 0 1 .446 1 .994v6.077c0 .549.447.994 1 .994.553 0 1-.445 1-.994V6.955c0-1.294-.839-2.387-2-2.798V2.98C18 1.337 16.654 0 15 0H5C3.346 0 2 1.337 2 2.98v1.177C.839 4.568 0 5.66 0 6.955v6.077c0 .549.447.994 1 .994z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15.02a.998.998 0 0 1-1 .993H7c-.552 0-1-.446-1-.994V5.961h8v9.058zM4 2.98a.998.998 0 0 1 1-.993h10c.552 0 1 .446 1 .994v.993H4v-.993z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairIcon2);
export default __webpack_public_path__ + "static/media/chair-icon-2.e510d006a1616e588889a406a8b1830e.svg";
export { ForwardRef as ReactComponent };